import { createApi } from '@reduxjs/toolkit/query/react';
import { REHYDRATE } from 'redux-persist';

import { settings } from '@/_config';

import baseQueryWithReAuth from '../helper/base-query-with-auth';

// Define a service using a base URL and expected endpoints
const customerPersistentApi = createApi({
  reducerPath: 'customerPersistentApi',
  baseQuery: baseQueryWithReAuth({ baseUrl: settings.baseURL[0], appName: 'ATP', authRequired: true }),
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === REHYDRATE && action?.payload) {
      return action.payload[reducerPath];
    }
    return undefined;
  },
  tagTypes: ['ME_DEPENDENCY'],
  endpoints: () => ({}),
});

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export default customerPersistentApi;
